<template>
  <div class="main-report">
    <nav-bar
      :title="$route.query.title || $t('reportIndex.工单')"
      :go-back="
        () => {
          $router.go(-1);
        }
      "
    />
    <van-notice-bar
      v-if="isMoreQuestion"
      :scrollable="true"
      :text="$t('reportIndex.问题提交后')"
    />
    <div class="content">
      <van-form ref="form" @submit="handleSubmit">
        <div class="field-item">
          <span class="label">{{ $t("reportIndex.问题分类") }}：</span>
          <van-field
            v-if="isMoreQuestion"
            readonly
            clickable
            v-model="ticketModel.name"
            class="select-field"
            :name="$t('reportIndex.问题分类')"
            :placeholder="$t('reportIndex.点击选择问题分类')"
            @click="handleChooseModel"
            :rules="[
              { required: true, message: $t('reportIndex.请选择问题分类') },
            ]"
          >
          </van-field>
        </div>

        <!-- <div class="tips" v-html="'fffff'"></div> -->
        <template v-for="(item, index) in fieldData">
          <div
            class="tips"
            :key="index"
            v-if="item.type === 'tip'"
            v-html="item.show_name"
          ></div>

          <div v-else :key="index" class="field-item">
            <span class="label"
              ><span v-if="item.is_must" class="red">* </span
              >{{ item.show_name }}：</span
            >
            <!-- 单选与多选已取消，不用判断-->
            <van-field
              :class="
                !['input', 'text', 'phone', 'role', 'role2'].includes(item.type)
                  ? 'select-field'
                  : 'input-field'
              "
              :readonly="
                !['input', 'text', 'phone', 'role', 'role2'].includes(item.type)
              "
              :clickable="
                !['input', 'text', 'phone', 'role', 'role2'].includes(item.type)
              "
              @click="onClickItem(item, index)"
              @blur="handleBlur(item)"
              v-model="item.form.text"
              :name="typeToForm[item.type]"
              :placeholder="item.notice_val"
              :disabled="
                (item.type === 'role' || item.type === 'service') && isErChong
              "
              :maxlength="200"
              :rules="[
                {
                  required: item.is_must == 1 ? true : false,
                  message: $t('reportIndex.请填写内容'),
                },
              ]"
            >
              <template #input v-if="item.type === 'files'">
                <van-uploader
                  accept="*"
                  v-model="item.form.value"
                  :after-read="afterRead"
                  :before-read="beforeRead"
                />
              </template>
            </van-field>
          </div>
        </template>
      </van-form>
    </div>
    <div class="footer">
      <van-button
        :disabled="!ticketModel.name"
        :loading="comLoading"
        block
        class="submit-btn"
        size="large"
        type="primary"
        @click="submit"
      >
        {{ $t("reportIndex.提交") }}
      </van-button>
    </div>
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentTime"
        :title="$t('reportIndex.选择日期')"
        :type="dateType"
        :min-date="minDate"
        @confirm="onConfirm"
        @cancel="showTimePicker = false"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :confirm-button-text="$t('app.确认')"
        :cancel-button-text="$t('app.取消')"
        :columns="currentColumns"
        @confirm="onConfirm"
        :loading="pickerLoading"
        @cancel="showPicker = false"
      >
        <van-search
          slot="title"
          v-model="keyword"
          :placeholder="$t('reportIndex.请输入搜索关键词')"
        />
      </van-picker>
    </van-popup>
    <NormalNotice
      :visible="showDescription"
      :data="description"
      :top="noticeTop"
      @close="showDescription = false"
    />
    <van-dialog
      :confirmButtonText="$t('reportIndex.查看渠道联系方式')"
      v-model="showChannelTip"
      :title="$t('reportIndex.提示')"
      show-cancel-button
      @confirm="handleConfirm"
    >
      <div class="tip-content" slot="default">
        {{ $t("reportIndex.该账号所属渠道为") }}
        {{ `${channelInfos && channelInfos.channelName}` }}
        {{ $t("reportIndex.请前往对应渠道处理") }}
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  getTicketRecordfield,
  getTicketModel,
  subTicket,
  getSelfRoleInfo,
} from "@/api/workOrder";
import { dateFormat } from "@/utils/util";
import { NormalNotice } from "@/components/Notice";
import { getServerList, getServerTypeList } from "@/api/user";
import { uploadFileOss } from "@/utils/uploadOss";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import storage from "@/utils/storage";

export default {
  name: "Report",
  data() {
    return {
      isLogin: false,
      keyword: "",
      // 描述显示
      showDescription: false,
      currentTime: null,
      // 描述内容
      description: {},
      submitLoading: false,
      showChannelTip: false,
      dateType: "time",
      typeToForm: {
        input: "input",
        text: "textarea",
        select: "textarea",
        phone: "input",
        service: "picker",
        files: "uploader",
        date: "datetimePicker",
        datetime: "datetimePicker",
        role: "input",
      },
      columns: [],
      showTimePicker: false,
      showPicker: false,
      uploader: [],
      fieldData: null,
      activeIndex: 0,
      serverType: [],
      minDate: new Date(1950, 0, 1),
      pickerLoading: false,
      comLoading: false,
      // 工单类型
      ticketModelOptions: [],
      ticketModel: { name: "" },
      isChageModel: false,
      isMoreQuestion: false,
      form_id: "",
      // 查询的角色信息
      channelInfos: {},
      acceptFile: "",
    };
  },
  components: { NormalNotice },
  computed: {
    ...mapGetters(["vuexInitData", "defaultRoleInfo"]),
    currentGameId() {
      return storage.getGameId();
    },
    isErChong() {
      return this.currentGameId === 2277 || this.currentGameId === 2242;
    },
    noticeTop() {
      // let height =
      //   (document.getElementsByClassName("nav-bar")[0] &&
      //     document.getElementsByClassName("nav-bar")[0].offsetHeight) ||
      //   40;
      return 0;
    },
    currentColumns() {
      return this.columns.filter((item) => {
        const str = (item.text && item.text.toLowerCase()) || "";
        return str.includes(this.keyword.toLowerCase());
      });
    },
    isHeroChannel() {
      return (
        this.channelInfos &&
        (this.channelInfos.channel === "hero" ||
          this.channelInfos.channel === "ihero" ||
          this.channelInfos.cid === 56 ||
          this.channelInfos.cid === 18 ||
          this.channelInfos.channel === "heropc")
      );
    },
  },
  watch: {
    showPicker: {
      handler(val) {
        if (!val) {
          this.keyword = "";
        }
      },
    },
  },
  async mounted() {
    window.staticFn.customEvent("visit_report_index_page", {
      game_id: storage.getGameId(),
    });
    if (localStorage.getItem("token")) {
      this.isLogin = true;

      if (
        !this.defaultRoleInfo ||
        !this.defaultRoleInfo.id ||
        this.defaultRoleInfo.id === "tourist"
      ) {
        this.$router.push({
          path: "/bind-roles",
        });
        return;
      }
      this.initInfos();
    } else {
      this.$eventBus.$emit("showLogin", true);
    }
    this.listenEvent();
  },
  beforeDestroy() {
    this.$eventBus.$off("loginSuccess");
  },
  methods: {
    async initInfos() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("iphone") != -1) {
        this.acceptFile = "";
      } else {
        this.acceptFile =
          "image/png,image/jpg,image/jpeg,image/gif,video/mp4,video/mov,video/m4v,video/avi,video/mkv,video/flv,video/wmv";
      }
      const { id, formToken, title } = this.$route.query;
      this.form_id = id;
      if (id && formToken && title !== this.$t("reportIndex.更多问题")) {
        this.ticketModel.name = title;
        await this.getFieldData({ id, token: formToken });
        if (Number(id) === 69) {
          this.getSelfRoleInfo();
        }
      } else {
        this.isMoreQuestion = true;
      }
      this.getRecordModel();
    },
    // 监听登录成功事件
    listenEvent() {
      this.$eventBus.$on("loginSuccess", () => {
        this.isLogin = true;
        this.initInfos();
      });
    },
    beforeRead(file) {
      // 判断文件类型是否为图片或者视频
      if (file.type.includes("image") || file.type.includes("video")) {
        return true;
      } else {
        this.$toast(this.$t("login.typeError"));
        return false;
      }
    },
    afterRead(file) {
      console.log({ file });
      file.status = "uploading";
      file.message = this.$t("reportIndex.上传中") + "...";
      let params = {
        file: file.file,
        accept: "png,jpg,jpeg,gif,mp4,mov,m4v,avi,mkv,flv,wmv,heic",
      };
      const _this = this;
      uploadFileOss(params)
        .then((res) => {
          file.status = "success";
          file.message = "";
          file.url = res.key;
        })
        .catch((err) => {
          file.status = "failed";
          file.message = _this.$t("reportIndex.上传失败");
          this.$toast(_this.$t("reportIndex.上传失败"));
        });
    },
    // 获取角色信息
    getSelfRoleInfo() {
      const { fieldData } = this;
      const findObj =
        fieldData && fieldData.find((item) => item.type === "service");
      const roleObj =
        fieldData && fieldData.find((item) => item.type === "role");

      if (
        findObj &&
        findObj.form &&
        findObj.form.value &&
        roleObj &&
        roleObj.form &&
        (roleObj.form.value || roleObj.form.text)
      ) {
        getSelfRoleInfo({
          server_id: findObj.form.value,
          game_id: storage.getGameId(),
          role_id: roleObj.form.value || roleObj.form.text,
        }).then((res) => {
          if (res.code === 0) {
            this.channelInfos = (res.data && res.data.role) || {};
            if (!this.isHeroChannel) {
              this.showChannelTip = true;
            }
          }
        });
      }
    },
    // 获取问题类型
    getRecordModel() {
      getTicketModel({ more: 1 }).then((res) => {
        if (res.code === 0) {
          res.data.forEach((item) => {
            item.text = item.name;
            item.value = item.id;
          });
          // this.columns = res.data;
          this.ticketModelOptions = res.data;
        }
      });
    },
    // 获取服务器类型
    getServerType() {
      getServerTypeList().then((res) => {
        if (res.code === 0) {
          res.data.forEach((item) => {
            item.text = item.name;
          });
          this.serverType = res.data;
        }
      });
    },
    // 区服列表请求后，直接添加到 picker 列表
    getServerList(id) {
      this.pickerLoading = true;
      getServerList({ server_type: id })
        .then((res) => {
          if (res.code === 0) {
            res.data.forEach((item) => {
              item.text = item.name;
              item.value = item.id;
            });
            this.columns = res.data;
          }
        })
        .finally(() => {
          this.pickerLoading = false;
        });
    },
    async getFieldData(params) {
      // let params = {
      //   id: this.$route.query.id,
      //   token: this.$route.query.formToken
      // };
      await getTicketRecordfield(params).then((res) => {
        if (res.code === 0) {
          const { items, description } = res.data || {};
          items.forEach((item) => {
            item.form = { text: "", value: "" };
            if (item.option_val) {
              item.selectOption = JSON.parse(item.option_val).map((item) => {
                item.text = item.key;
                item.value = item.val;
                return item;
              });
            }
            if (item.type === "files") {
              item.form = { text: "", value: [] };
            }
            // 判断有没有需要区服的字段
            if (item.type === "service") {
              if (this.defaultRoleInfo && this.defaultRoleInfo.f_id) {
                item.form = {
                  text: this.defaultRoleInfo.server_name || "",
                  value: this.defaultRoleInfo.f_id || "",
                };
              }
              this.getServerType();
            }
            // 判断电话号码
            if (item.type === "phone") {
              if (this.vuexInitData && this.vuexInitData.user_info) {
                item.form = {
                  text: this.vuexInitData.user_info.phone || "",
                  value: "",
                };
              }
            }

            // 判断角色名
            if (item.type === "role") {
              if (this.defaultRoleInfo && this.defaultRoleInfo.role_id) {
                item.form = {
                  text: this.defaultRoleInfo.role_id || "",
                  value: "",
                };
              }
            }

            this.currentTime = new Date();
          });
          this.fieldData = items;
          if (description) {
            this.description = {
              title: this.$route.query.title,
              content: description,
            };
            this.showDescription = true;
          }
        }
      });
    },
    // 失去焦点
    handleBlur(data) {
      const { id } = this.$route.query;
      if (Number(id) === 69 && data.type === "role") {
        this.getSelfRoleInfo();
      }
    },
    onClickItem(item, index) {
      this.activeIndex = index;
      if (item.type === "date" || item.type === "datetime") {
        this.dateType = item.type;
        this.showTimePicker = true;
      } else if (item.type === "select") {
        this.showPicker = true;
        this.columns = item.selectOption;
      } else if (item.type === "service") {
        this.showPicker = true;
        this.columns = this.serverType;
      }
    },
    handleChooseModel() {
      this.columns = this.ticketModelOptions;
      this.showPicker = true;
      this.isChageModel = true;
    },
    onConfirm(value) {
      this.keyword = "";
      if (this.showTimePicker) {
        this.showTimePicker = false;
        if (this.dateType === "date") {
          this.fieldData[this.activeIndex].form.text =
            dayjs(value).format("YYYY-MM-DD");
        } else {
          this.fieldData[this.activeIndex].form.text =
            dayjs(value).format("YYYY-MM-DD HH:mm");
        }
      } else if (this.showPicker) {
        // 选区服类型，再选区服
        if (this.columns === this.serverType) {
          this.getServerList(value.id);
        } else if (this.isChageModel) {
          this.ticketModel = value;
          this.showPicker = false;
          this.isChageModel = false;
          this.form_id = value.form_id;
          this.getFieldData({ id: value.form_id, token: value.token });
        } else {
          this.showPicker = false;
          this.fieldData[this.activeIndex].form = value;
        }
      }
    },
    submit() {
      this.$refs.form.submit();
    },
    handleSubmit(value) {
      let params = {};
      if (sessionStorage.getItem("from")) {
        params.qd = sessionStorage.getItem("from");
      }
      if (Number(this.$route.query.id) === 69) {
        if (!this.isHeroChannel) {
          this.showChannelTip = true;
          return;
        }
      }
      this.fieldData
        .filter((item) => {
          if (item.type !== "tip") return true;
        })
        .forEach((item) => {
          if (item.type === "select") {
            // select  给后端 text 直接显示
            params[item.key.trim()] = item.form.text || item.form.value || "";
          } else {
            params[item.key.trim()] = item.form.value || item.form.text || "";
          }
        });

      if (params.files && params.files.length > 0) {
        if (!params.files.every((item) => item.status === "success")) {
          this.$toast(this.$t("reportIndex.文件上传中"));
          return;
        }
        params.files = params.files.map((item) => {
          return item.url;
        });
      }

      // params.form_id = Number(this.$route.query.id);
      // params.files = params.files.map(item=>{
      //   return item.url;
      // });
      params.form_id = Number(this.form_id);
      params.role_name = this.defaultRoleInfo.role_name;

      if (this.$route.query.source) {
        params.source = this.$route.query.source;
      }
      const { session_id } = this.$route.query;
      if (session_id) {
        params.session_id = Number(session_id);
      }

      this.comLoading = true;
      subTicket(params)
        .then((res) => {
          if (res.code === 0) {
            window.staticFn.customEvent("submit_report", {
              type: "report",
              game_id: storage.getGameId(),
              form_id: this.form_id,
              role_name: this.defaultRoleInfo.role_name,
              from: sessionStorage.getItem("from") || "",
            });
            const id = res.data && res.data.id;
            this.$router.replace({
              name: "ReportResult",
              query: {
                id,
                title: this.$route.query.title,
              },
            });
          }
        })
        .finally(() => {
          this.comLoading = false;
        });
    },
    handleConfirm() {
      window.open("https://docs.qq.com/doc/DWkJoQ3JNbXJyYWtB", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.main-report {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;

  .tip-content {
    padding: 8px 20px 26px;
    color: #646566;
    font-size: 14px;
    text-align: center;
  }

  .content {
    flex: 1;
    // overflow: scroll;
    margin-top: 8px;
    padding: 12px 10px;
    box-sizing: border-box;
    background-color: #fff;
    .field-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        // min-width: 84px;
        // margin-right: 5px;
        margin-bottom: 8px;
        color: #555;
        font-size: 14px;
      }
      .input-field {
        border: 1px solid rgba(0, 0, 0, 0.04);
        box-sizing: border-box;
      }
      .select-field {
        background-color: #fbfbfb;
        box-sizing: border-box;
      }
    }
  }

  .footer {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    // height: 60px;
    padding: 20px 10px;
    box-sizing: border-box;
    background-color: #fff;
    .submit-btn {
      height: 40px;
      font-size: 15px;
      font-weight: 500;
    }
  }

  .tips {
    margin-bottom: 10px;
    padding: 6px 20px;
    color: red;
    font-size: 12px;
    line-height: 22px;
    font-weight: 500;
    background-color: #fff6e5;
    border-radius: 6px;
    border: 1px solid @gold;
  }
  /deep/ .van-search {
    padding: 0;
  }
}
</style>
